import { createSetContactsDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useContactsData = params => {
  return useGetAndSet("contacts", params, createSetContactsDataAction);
};
